import AttendApplicationApprovalV2Page from './AttendApplicationApprovalV2Page'

export default AttendApplicationApprovalV2Page